import { ReactNode, FC } from 'react';
import EventEmitter from 'eventemitter3';
import { EmitterContext, EmitterEventData, EmitterEventType, EmitterListener } from './helpers';

interface Props {
  children: ReactNode;
}

const EmitterBus = new EventEmitter();
const listeners: Record<EmitterEventType, EmitterListener[]> = {
  'stream-error': [],
};

export const EmitterProvider: FC<Props> = ({ children }) => {
  const subscribe = <T extends EmitterEventType>(
    types: T | T[],
    listenerFn: (data?: EmitterEventData[T]) => void
  ) => {
    (Array.isArray(types) ? types : [types]).forEach((type) => {
      const exists = listeners[type].some((existingListener) => existingListener === listenerFn);
      if (exists) {
        return;
      }

      EmitterBus.on(type, listenerFn);
      listeners[type].push(listenerFn);
    });
  };

  const unsubscribe = <T extends EmitterEventType>(
    types: T | T[],
    listenerFn: (data?: EmitterEventData[T]) => void
  ) => {
    (Array.isArray(types) ? types : [types]).forEach((type) => {
      const listenerIndex = listeners[type].findIndex(
        (existingListener) => existingListener === listenerFn
      );
      if (listenerIndex > -1) {
        listeners[type].splice(listenerIndex, 1);
        EmitterBus.removeListener(type, listenerFn);
      }
    });
  };

  const emit = <T extends EmitterEventType>(type: T, data?: EmitterEventData[T]) => {
    EmitterBus.emit(type, data);
  };

  return (
    <EmitterContext.Provider value={{ emit, subscribe, unsubscribe }}>
      {children}
    </EmitterContext.Provider>
  );
};
